/* import __COLOCATED_TEMPLATE__ from './horizontal-stack.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();